export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0
}

export function unique<T>(values: T[]): T[] {
  return Array.from(new Set(values))
}

export function arraysEqual(a: string[] | undefined, b: string[]): boolean {
  return Boolean(a && a.length === b.length && a.every((value, index) => value === b[index]))
}

export function isValidPort(port: number): boolean {
  return Number.isInteger(port) && port > 0 && port <= 65535
}

export function delay(milliseconds: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, milliseconds))
}

export function collectRepeatedOption(value: string, previous: string[] = []): string[] {
  return [...previous, value]
}

export function assertChoice<T extends string>(
  label: string,
  value: string | undefined,
  choices: readonly T[]
): asserts value is T | undefined {
  if (value && !choices.includes(value as T)) {
    throw new Error(`Invalid ${label} "${value}". Choose one of: ${choices.join(', ')}.`)
  }
}

export function stringifyProjectJson(value: unknown): string {
  return `${compactShortStringArrays(JSON.stringify(value, null, 2))}\n`
}

function compactShortStringArrays(json: string): string {
  return json.replace(
    /\[\n((?:[ \t]+"(?:[^"\\]|\\.)*",?\n)+)([ \t]*)\]/g,
    (match: string, entries: string) => {
      const values = entries
        .trim()
        .split('\n')
        .map((line) => line.trim())

      const inline = `[${values.map((entry) => entry.replace(/,$/, '')).join(', ')}]`
      return inline.length <= 70 ? inline : match
    }
  )
}
